/* Pantalla de elegir un pack mezclado (snippets/lp-pack-elegir.liquid): al pulsar «Añadir pack» en las tarjetas de Regalos (sections/lp-bundles.liquid) y en el resultado del test de regalo
   (sections/lp-gift-quiz.liquid). Antes era lp-bundles.js; el 29-10-2026 se generaliza para que no dependa de la tarjeta (.lp-bun__card) sino de un contenedor cualquiera con data-bun-scope
   que tenga a la vez el botón de añadir (data-pack-buy: un enlace en Regalos, un botón en el test) y el <dialog>.
   El snippet deja en un JSON (data-bun-d) las variantes de cada línea (con su clase de precio «k») y, por cada combinación de clases, el total, el ahorro y el «por separado» ya formateados:
   aquí solo se elige entre esos valores (nada de cuentas ni de formato de dinero, G14). Al confirmar, se pulsa el «Añadir pack» del contenedor con los ids elegidos y lp-cart.js hace el resto
   (mete las líneas y abre el carrito lateral). Sin este fichero o sin <dialog>, «Añadir pack» es lo de siempre, con las variantes por defecto.
   Si la página carga este fichero dos veces (Regalos tiene el test y las tarjetas), cada JSON se engancha una sola vez (data-bun-on). */
(() => {
  document.querySelectorAll('[data-bun-d]').forEach((j) => {
    const card = j.closest('[data-bun-scope]');
    const dlg = card && card.querySelector('[data-bun-dlg]');
    const buy = card && card.querySelector('[data-pack-buy]');
    if (!dlg || !buy || typeof dlg.showModal !== 'function' || j.dataset.bunOn) return;
    let D;
    try {
      D = JSON.parse(j.textContent);
    } catch (e) {
      return;
    }
    if (!D || !D.l || !D.c || !D.d) return;
    j.dataset.bunOn = '1';

    const lines = [...dlg.querySelectorAll('[data-bun-line]')];
    const out = dlg.dataset.out || '';
    const defaults = () => D.d.map((d) => ({ c: d[0], p: d[1] }));
    let sel = defaults();
    // Lo que lleva el botón por defecto: se restaura tras cada añadido (en el test es un <button> sin enlace)
    const keep = { href: buy.getAttribute('href'), items: buy.dataset.packItems };
    const find = (i, c, p) => D.l[i].find((v) => v.c === c && v.p === p);
    const text = (sel2, v) => dlg.querySelectorAll(sel2).forEach((n) => (n.textContent = v));
    const chosen = () => D.l.map((_, i) => find(i, sel[i].c, sel[i].p));

    const render = () => {
      const now = chosen();
      lines.forEach((li, i) => {
        const v = now[i];
        if (!v) return;
        const n = li.querySelector('[data-bun-n]');
        if (n) n.textContent = v.t;
        // La foto y el nombre llevan a la ficha de la variante elegida (29-10-2026)
        if (v.u) li.querySelectorAll('[data-bun-lnk]').forEach((a) => a.setAttribute('href', v.u));
        const im = li.querySelector('[data-bun-img]');
        if (im) {
          const s = v.s || im.dataset.bunBase;
          if (s && im.getAttribute('src') !== s) im.src = s;
        }
        // Cada opción, con lo demás como está elegido: si esa variante no existe o está agotada, deshabilitada y con aviso
        const off = [];
        li.querySelectorAll('[data-bun-o]').forEach((r) => {
          const ax = r.dataset.bunO;
          const val = Number(r.value);
          const w = find(i, ax === 'c' ? val : sel[i].c, ax === 'p' ? val : sel[i].p);
          r.checked = val === sel[i][ax];
          r.disabled = !w || !w.a;
          if (r.disabled) off.push(r.closest('label').title);
        });
        const warn = li.querySelector('[data-bun-warn]');
        if (warn) {
          warn.textContent = off.length ? `${off.join(', ')} · ${out}` : '';
          warn.hidden = !off.length;
        }
      });
      const c = D.c[now.map((v) => (v ? v.k : 0)).concat([0, 0, 0]).slice(0, 3).join('-')];
      if (!c) return;
      text('[data-bun-p]', c.t);
      text('[data-bun-s]', c.s);
      text('[data-bun-a]', c.a);
      // 29-10-2026: ~~las dos líneas se ocultaban juntas con c.s~~ → «ahorras» (c.s = el descuento) y «por separado» tachado (c.a) se ocultan cada una por lo suyo
      dlg.querySelectorAll('[data-bun-sv]').forEach((n) => (n.hidden = !c.s));
      dlg.querySelectorAll('[data-bun-ap]').forEach((n) => (n.hidden = !c.a));
    };

    dlg.addEventListener('change', (e) => {
      const r = e.target.closest('[data-bun-o]');
      const li = r && r.closest('[data-bun-line]');
      if (!li) return;
      sel[lines.indexOf(li)][r.dataset.bunO] = Number(r.value);
      render();
    });

    let go = false;
    buy.setAttribute('aria-haspopup', 'dialog');
    // «Añadir pack» abre la pantalla (y no llega a lp-cart.js); solo pasa de largo cuando lo pulsa la propia confirmación
    buy.addEventListener('click', (e) => {
      if (go) return;
      e.preventDefault();
      e.stopPropagation();
      render();
      dlg.showModal();
    });

    dlg.querySelector('[data-bun-close]').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close(); // el fondo
    });
    dlg.addEventListener('close', () => buy.focus({ preventScroll: true }));

    dlg.querySelector('[data-bun-ok]').addEventListener('click', () => {
      const ids = chosen().map((v) => v.id);
      // Dos unidades de la misma variante (packs del mismo producto) van en UNA línea con cantidad 2
      const qty = [...new Set(ids)].map((id) => ({ id, quantity: ids.filter((x) => x === id).length }));
      if (keep.href !== null) buy.href = `${D.cart}/${qty.map((l) => `${l.id}:${l.quantity}`).join(',')}`;
      if (keep.items !== undefined) buy.dataset.packItems = JSON.stringify(qty);
      sel = defaults();
      dlg.close();
      go = true;
      buy.click(); // lp-cart.js lee los ids al instante; sin carrito lateral, el enlace va al pago
      go = false;
      if (keep.href !== null) buy.setAttribute('href', keep.href);
      if (keep.items !== undefined) buy.dataset.packItems = keep.items;
    });
  });
})();

/* Packs temáticos (03-11-2026; snippets/lp-pack-tematico.liquid): el pack es UN producto con sus opciones, así que aquí se elige una variante del pack. Bloque aparte (JSON data-bun-t): lo de
   arriba (data-bun-d, packs de 2 y mezclados) no cambia. El JSON trae cada variante con sus valores («o»), su nombre, su total y su «por separado» ya formateados (G14: aquí no se cuenta dinero).
   Cada pastilla lleva su opción (data-bun-k) y su valor; la combinación que no existe o está agotada sale deshabilitada. Al confirmar, el «Añadir pack» del contenedor pasa a llevar UNA línea, la
   variante elegida, y se pulsa: lp-cart.js la añade y abre el carrito lateral (sin carrito lateral, el enlace /cart/<id>:1 va al pago). */
(() => {
  document.querySelectorAll('[data-bun-t]').forEach((j) => {
    const card = j.closest('[data-bun-scope]');
    const dlg = card && card.querySelector('[data-bun-dlg]');
    const buy = card && card.querySelector('[data-pack-buy]');
    if (!dlg || !buy || typeof dlg.showModal !== 'function' || j.dataset.bunOn) return;
    let D;
    try {
      D = JSON.parse(j.textContent);
    } catch (e) {
      return;
    }
    if (!D || !Array.isArray(D.v) || !Array.isArray(D.d)) return;
    j.dataset.bunOn = '1';

    const out = dlg.dataset.out || '';
    let sel = D.d.slice();
    const keep = { href: buy.getAttribute('href'), items: buy.dataset.packItems };
    const find = (s) => D.v.find((v) => v.o.every((x, k) => x === s[k]));
    const text = (q, v) => dlg.querySelectorAll(q).forEach((n) => (n.textContent = v));

    /* Foto de arriba: empieza con la del pack (la que pinta el Liquid, im[0]) y sigue a la última elección (v.i[k] = foto de la pieza que elige la opción k). La caja reserva su sitio (16:9),
       así que cambiar de foto no mueve nada. Se precarga la nueva y se cambia al cargar, con un fundido corto (sin él con «reducir movimiento», por CSS). */
    const img = dlg.querySelector('.lp-bunp__heroimg');
    const IM = Array.isArray(D.im) ? D.im : [];
    const home = img ? { s: img.getAttribute('src'), w: img.getAttribute('srcset'), z: img.getAttribute('sizes'), a: img.getAttribute('alt') } : null;
    const PZ = '(min-width: 990px) 280px, (min-width: 600px) 300px, 200px';
    const at = (u, w) => u.replace(/([?&])width=\d+/, `$1width=${w}`);
    let cur = 0;
    const pic = (i, now) => {
      if (!img || i === cur) return;
      const m = i === 0 ? home : IM[i] && { s: at(IM[i].u, 450), w: [300, 450, 600].map((w) => `${at(IM[i].u, w)} ${w}w`).join(', '), z: PZ, a: IM[i].a };
      if (!m) return;
      cur = i;
      const put = () => {
        if (cur !== i) return;
        img.sizes = m.z || '';
        img.srcset = m.w || '';
        img.src = m.s;
        img.alt = m.a || '';
        img.classList.remove('is-out');
      };
      if (now) return put();
      const pre = new Image();
      pre.sizes = m.z || '';
      pre.srcset = m.w || '';
      pre.onload = pre.onerror = put;
      img.classList.add('is-out');
      pre.src = m.s;
    };

    /* Miniaturas de «Incluye»: una por pieza, en el orden de custom.pack_piezas; siguen a la variante elegida (v.p[j] = índice de su foto). */
    const thumbs = [...dlg.querySelectorAll('.pack-piezas__img')];
    const thumb = (v) => {
      if (!v || !Array.isArray(v.p) || thumbs.length !== v.p.length) return;
      thumbs.forEach((t, j) => {
        const m = IM[v.p[j]];
        if (!m) return;
        t.srcset = `${at(m.u, 80)} 80w, ${at(m.u, 160)} 160w`;
        t.src = at(m.u, 160);
      });
    };

    const render = () => {
      const v = find(sel);
      const off = [];
      dlg.querySelectorAll('[data-bun-k]').forEach((r) => {
        const k = Number(r.dataset.bunK);
        const s = sel.slice();
        s[k] = r.value;
        const w = find(s);
        r.checked = r.value === sel[k];
        r.disabled = !w || !w.av;
        if (r.disabled && !off.includes(r.value)) off.push(r.value);
      });
      sel.forEach((x, k) => text(`[data-bun-sel="${k}"]`, x));
      const warn = dlg.querySelector('[data-bun-warn]');
      if (warn) {
        warn.textContent = off.length ? `${off.join(', ')} · ${out}` : '';
        warn.hidden = !off.length;
      }
      const ok = dlg.querySelector('[data-bun-ok]');
      if (ok) ok.disabled = !v || !v.av;
      if (!v) return;
      thumb(v);
      text('[data-bun-p]', v.t);
      text('[data-bun-a]', v.a);
      dlg.querySelectorAll('[data-bun-ap]').forEach((n) => (n.hidden = !v.a));
    };

    dlg.addEventListener('change', (e) => {
      const r = e.target.closest('[data-bun-k]');
      if (!r) return;
      const k = Number(r.dataset.bunK);
      const before = find(sel);
      sel[k] = r.value;
      const after = find(sel);
      if (before && after && after.i && before.i[k] !== after.i[k]) pic(after.i[k]);
      render();
    });

    let go = false;
    buy.setAttribute('aria-haspopup', 'dialog');
    buy.addEventListener('click', (e) => {
      if (go) return;
      e.preventDefault();
      e.stopPropagation();
      pic(0, true);
      render();
      dlg.showModal();
    });
    dlg.querySelector('[data-bun-close]').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });
    dlg.addEventListener('close', () => buy.focus({ preventScroll: true }));

    dlg.querySelector('[data-bun-ok]').addEventListener('click', () => {
      const v = find(sel);
      if (!v || !v.av) return;
      if (keep.href !== null) buy.href = `${D.cart}/${v.id}:1`;
      if (keep.items !== undefined) buy.dataset.packItems = JSON.stringify([{ id: v.id, quantity: 1 }]);
      sel = D.d.slice();
      dlg.close();
      go = true;
      buy.click();
      go = false;
      if (keep.href !== null) buy.setAttribute('href', keep.href);
      if (keep.items !== undefined) buy.dataset.packItems = keep.items;
    });
  });
})();

/* Packs temáticos «por unidad» (03-11-2026; snippets/lp-pack-unidades.liquid, metacampo custom.pack_unidades): cada unidad tiene su fila de pastillas. Bloque aparte (JSON data-bun-tu): lo de arriba no cambia.
   El JSON de la página lleva solo la estructura (piezas, ejes, opciones), las fotos y el estado inicial (las pastillas marcadas). El MAPA combinación → [variante, total, por separado] (hasta 360 entradas)
   se pide UNA vez por producto y página, al abrir la hoja (o al acercarse al botón), a /products/<handle>?view=pack-mapa: ya trae los importes formateados, aquí solo se elige entre textos (G14).
   Clave de la combinación (README de packs-por-unidad-02.mjs): por opción y por parte, los valores de las unidades ORDENADOS por su posición en «valores» y unidos con sep.unidad; un eje común o una pieza de
   1 unidad, su valor; partes con sep.parte; opciones con sep.clave. La 2.ª, 3.ª… unidad de un eje copia a la 1.ª hasta que el cliente la toca. La foto sigue a la última pastilla tocada. Desde el 04-11-2026 la hoja pinta una tarjeta por unidad (foto pequeña, nombre, resumen y pastillas) y, arriba, la fila de los ejes comunes; la lógica de aquí no cambia.
   Sin mapa (red caída) «Añadir» queda deshabilitado con el aviso data-err: nunca se mete una variante adivinada. */
(() => {
  const maps = new Map();
  const loadMap = (url) => {
    if (!maps.has(url)) {
      maps.set(
        url,
        fetch(url, { credentials: 'same-origin' }) // sin Accept: application/json: con él Shopify devuelve el JSON estándar del producto e ignora ?view=
          .then((r) => {
            if (!r.ok) throw new Error(r.status);
            return r.json();
          })
          .then((j) => {
            if (!j || !j.m || !Object.keys(j.m).length) throw new Error('vacío');
            return j.m;
          })
          .catch((e) => {
            maps.delete(url);
            throw e;
          })
      );
    }
    return maps.get(url);
  };

  document.querySelectorAll('[data-bun-tu]').forEach((j) => {
    let D;
    try {
      D = JSON.parse(j.textContent);
    } catch (e) {
      return;
    }
    if (!D || !Array.isArray(D.piezas) || !Array.isArray(D.opciones) || !D.map) return;
    // En la portada y el test, el contenedor data-bun-scope; en la ficha del pack (D.page), los botones D.buy de toda la página (comprar y barra fija)
    const card = D.page ? document : j.closest('[data-bun-scope]');
    const dlg = (D.page ? j.parentElement : card) && (D.page ? j.parentElement : card).querySelector('[data-bun-dlg]');
    const buys = card ? [...card.querySelectorAll(D.page ? D.buy : '[data-pack-buy]')].slice(0, D.page ? 6 : 1) : [];
    let buy = buys[0];
    if (!dlg || !buy || typeof dlg.showModal !== 'function' || j.dataset.bunOn) return;
    j.dataset.bunOn = '1';

    const sep = D.sep || {};
    const SU = sep.unidad || ' + ';
    const SP = sep.parte || ' · ';
    const SC = sep.clave || '|';
    const out = dlg.dataset.out || '';
    const keeps = new Map(buys.map((b) => [b, { href: b.getAttribute('href'), items: b.dataset.packItems }]));
    const text = (q, v) => dlg.querySelectorAll(q).forEach((n) => (n.textContent = v));
    const eje = (pz, name) => D.piezas[pz].ejes.find((e) => e.eje === name);

    /* Estado: «pieza|eje» → valores por unidad. Sale de las pastillas marcadas (el Liquid marca las de la variante por defecto). */
    const radios = [...dlg.querySelectorAll('input[data-bun-pz]')];
    const rk = (r) => `${r.dataset.bunPz}|${r.dataset.bunEj}`;
    const read = () => {
      const s = {};
      radios.forEach((r) => {
        if (r.checked) (s[rk(r)] = s[rk(r)] || [])[Number(r.dataset.bunUn)] = r.value;
      });
      return s;
    };
    const first = read();
    let S = JSON.parse(JSON.stringify(first));
    const touched = new Set();

    const key = () => {
      try {
        return D.opciones
          .map((o) =>
            o.partes
              .map((pt) => {
                const e = eje(pt.pieza, pt.eje);
                if (e.modo === 'fijo') return e.valor;
                const a = S[`${pt.pieza}|${pt.eje}`];
                if (e.modo === 'unidad' && D.piezas[pt.pieza].unidades > 1) {
                  return a
                    .slice()
                    .sort((x, y) => e.valores.indexOf(x) - e.valores.indexOf(y))
                    .join(SU);
                }
                return a[0];
              })
              .join(SP)
          )
          .join(SC);
      } catch (e) {
        return '';
      }
    };

    /* Foto de arriba: como en los packs de siempre (caja reservada, fundido corto, im[0] = la del pack). */
    const img = dlg.querySelector('.lp-bunp__heroimg');
    const IM = Array.isArray(D.im) ? D.im : [];
    const IV = D.iv || {};
    const home = img ? { s: img.getAttribute('src'), w: img.getAttribute('srcset'), z: img.getAttribute('sizes'), a: img.getAttribute('alt') } : null;
    const PZ = '(min-width: 990px) 560px, (min-width: 600px) 450px, 300px';
    const at = (u, w) => u.replace(/([?&])width=\d+/, `$1width=${w}`);
    let cur = 0;
    const pic = (i, now) => {
      if (!img || i === cur) return;
      const m = i === 0 ? home : IM[i] && { s: at(IM[i].u, 450), w: [300, 450, 600].map((w) => `${at(IM[i].u, w)} ${w}w`).join(', '), z: PZ, a: IM[i].a };
      if (!m) return;
      cur = i;
      const put = () => {
        if (cur !== i) return;
        img.sizes = m.z || '';
        img.srcset = m.w || '';
        img.src = m.s;
        img.alt = m.a || '';
        img.classList.remove('is-out');
      };
      if (now) return put();
      const pre = new Image();
      pre.sizes = m.z || '';
      pre.srcset = m.w || '';
      pre.onload = pre.onerror = put;
      img.classList.add('is-out');
      pre.src = m.s;
    };

    /* Foto pequeña de cada tarjeta de unidad (04-11-2026; antes, miniaturas de «Incluye»): una por unidad (data-bun-th = pieza|eje|unidad), con la foto del valor elegido en esa unidad. Sin src hasta que se abre
       la hoja (el primer render() corre en el clic de «Añadir pack»): al cargar la página no se descarga ninguna. Las tarjetas de piezas sin eje de unidad llevan su foto ya en el Liquid. */
    const thumbs = [...dlg.querySelectorAll('[data-bun-th]')];
    const thumb = () => {
      thumbs.forEach((t) => {
        const [pz, ej, u] = t.dataset.bunTh.split('|');
        const val = (S[`${pz}|${ej}`] || [])[Number(u)];
        const m = IM[IV[`${pz}|${ej}|${val}`]];
        if (!m) return;
        t.srcset = `${at(m.u, 88)} 88w, ${at(m.u, 176)} 176w, ${at(m.u, 264)} 264w`;
        t.sizes = '88px';
        t.src = at(m.u, 176);
      });
    };

    /* Resumen de cada tarjeta («Rosa / 5200 mAh»): los valores elegidos de los ejes de la pieza, de unidad (el de esa unidad) y común (el de todo el pack), en el orden del metacampo. */
    const cards = [...dlg.querySelectorAll('[data-bun-card]')];
    const summary = () => {
      cards.forEach((c) => {
        const n = c.querySelector('[data-bun-n]');
        if (!n) return;
        const [pz, u] = c.dataset.bunCard.split('|');
        n.textContent = D.piezas[Number(pz)].ejes
          .map((e) => (e.modo === 'unidad' ? (S[`${pz}|${e.eje}`] || [])[Number(u)] : e.modo === 'comun' ? (S[`${pz}|${e.eje}`] || [])[0] : ''))
          .filter(Boolean)
          .join(' / ');
      });
    };

    let M = null;
    let failed = false;
    const render = () => {
      radios.forEach((r) => (r.checked = (S[rk(r)] || [])[Number(r.dataset.bunUn)] === r.value));
      dlg.querySelectorAll('[data-bun-row]').forEach((f) => {
        const [pz, ej, u] = f.dataset.bunRow.split('|');
        const n = f.querySelector('[data-bun-sel]');
        if (n) n.textContent = (S[`${pz}|${ej}`] || [])[Number(u)] || '';
      });
      thumb();
      summary();
      const v = M && M[key()];
      const warn = dlg.querySelector('[data-bun-warn]');
      if (warn) {
        warn.textContent = failed ? dlg.dataset.err || '' : M && !v ? out : '';
        warn.hidden = !warn.textContent;
      }
      const ok = dlg.querySelector('[data-bun-ok]');
      if (ok) ok.disabled = !v;
      if (!v) return;
      text('[data-bun-p]', v[1]);
      text('[data-bun-a]', v[2]);
      dlg.querySelectorAll('[data-bun-ap]').forEach((n) => (n.hidden = !v[2]));
    };

    const load = () =>
      loadMap(D.map).then(
        (m) => {
          M = m;
          failed = false;
          render();
        },
        () => {
          failed = true;
          render();
        }
      );
    // Pedir el mapa al acercarse al botón gana el tiempo del toque; sin acercarse, se pide al abrir
    buys.forEach((b) => ['pointerenter', 'touchstart', 'focus'].forEach((ev) => b.addEventListener(ev, () => !M && loadMap(D.map).catch(() => {}), { passive: true, once: true })));

    dlg.addEventListener('change', (e) => {
      const r = e.target.closest('input[data-bun-pz]');
      if (!r) return;
      const k = rk(r);
      const u = Number(r.dataset.bunUn);
      S[k] = S[k] || [];
      S[k][u] = r.value;
      touched.add(`${k}|${u}`);
      const ej = eje(Number(r.dataset.bunPz), r.dataset.bunEj);
      // La 1.ª unidad arrastra a las que el cliente aún no ha tocado
      if (u === 0 && ej && ej.modo === 'unidad') S[k].forEach((_, i) => i > 0 && !touched.has(`${k}|${i}`) && (S[k][i] = r.value));
      const i = IV[`${r.dataset.bunPz}|${r.dataset.bunEj}|${r.value}`];
      if (i) pic(i);
      render();
    });

    let go = false;
    buys.forEach((b) => {
      b.setAttribute('aria-haspopup', 'dialog');
      b.addEventListener('click', (e) => {
        if (go) return;
        e.preventDefault();
        e.stopPropagation();
        buy = b;
        pic(0, true);
        render();
        load();
        dlg.showModal();
      });
    });
    dlg.querySelector('[data-bun-close]').addEventListener('click', () => dlg.close());
    dlg.addEventListener('click', (e) => {
      if (e.target === dlg) dlg.close();
    });
    dlg.addEventListener('close', () => buy.focus({ preventScroll: true }));

    dlg.querySelector('[data-bun-ok]').addEventListener('click', () => {
      const v = M && M[key()];
      if (!v) return;
      const keep = keeps.get(buy);
      if (keep.href !== null) buy.href = `${D.cart}/${v[0]}:1`;
      if (keep.items !== undefined) buy.dataset.packItems = JSON.stringify([{ id: v[0], quantity: 1 }]);
      S = JSON.parse(JSON.stringify(first));
      touched.clear();
      dlg.close();
      go = true;
      buy.click();
      go = false;
      if (keep.href !== null) buy.setAttribute('href', keep.href);
      if (keep.items !== undefined) buy.dataset.packItems = keep.items;
    });
  });
})();
